import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './i18n/index.js'
import App from './App.jsx'
import { BrowserRouter } from 'react-router-dom'; // ✅ important
import { ThemeProvider } from './context/ThemeContext.jsx';


createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ThemeProvider>
      <BrowserRouter>
      <App />

      </BrowserRouter>
    </ThemeProvider>
  </StrictMode>,
)
